import GlobalLoader from '@/components/atom/GlobalLoader.vue'

export default {
    install(app) {
        app.component('GlobalLoader', GlobalLoader)
    }
}